document.addEventListener('DOMContentLoaded', () => {
  const modalEl = document.getElementById('search-modal');
  if (!modalEl) return;

  const trigger = document.querySelector('[data-mir-search-open]');
  const closeButton = modalEl.querySelector('[data-mir-search-close]');
  const input = modalEl.querySelector('#mir-search-input');
  const openClass = 'is-open';

  const openModal = () => {
    modalEl.classList.add(openClass);
    modalEl.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    if (input) {
      input.focus();
      input.select();
    }
  };

  const closeModal = () => {
    modalEl.classList.remove(openClass);
    modalEl.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  };

  if (trigger) {
    trigger.addEventListener('click', (event) => {
      event.preventDefault();
      openModal();
    });
  }

  if (closeButton) {
    closeButton.addEventListener('click', () => {
      closeModal();
    });
  }

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && modalEl.classList.contains(openClass)) {
      closeModal();
    }
  });
});
